// This file is a placeholder that gets overwritten in the build directory.
export const base64WorkerScript = '';
